import { Head } from '@inertiajs/react';
import type { LandingsSkull } from '@/types';
import { RotatingSkull } from './components/rotating-skull';

// `app/(public)/26-mx/skull/page.tsx`.
export default function Skull({ title, description }: LandingsSkull) {
  return (
    <>
      <Head title={title}>
        <meta name="description" content={description} />
      </Head>
      <main className="relative min-h-dvh w-full overflow-hidden bg-background text-foreground md:h-dvh">
        <RotatingSkull />
      </main>
    </>
  );
}
